"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TitleInner = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("../../constants/theme");
var _excluded = ["variant", "children", "elementType"];
var elementMap = {
  large: 'h1',
  regular: 'h2',
  small: 'h3',
  tiny: 'h4',
  micro: 'h5'
};
var TitleInner = exports.TitleInner = _styledComponents["default"].h1.withConfig({
  displayName: "Title__TitleInner",
  componentId: "sc-19bmius-0"
})(["font-family:", ";margin:0;padding:0;font-weight:700;white-space:pre-line;", " strong{display:block;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily.title;
}, function (_ref2) {
  var _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'regular' : _ref2$variant,
    theme = _ref2.theme;
  return (0, _theme.getFontCss)(theme.fontSizes.title[variant]);
});
var Title = function Title(_ref3) {
  var _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'regular' : _ref3$variant,
    children = _ref3.children,
    _ref3$elementType = _ref3.elementType,
    elementType = _ref3$elementType === void 0 ? elementMap[variant] : _ref3$elementType,
    rest = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  return /*#__PURE__*/_react["default"].createElement(TitleInner, Object.assign({
    as: elementType,
    variant: variant
  }, rest), children);
};
var _default = exports["default"] = Title;
//# sourceMappingURL=Title.js.map